import React, { useState, useRef, useEffect } from "react";
import moment from "moment";
import { Button, Icon } from 'semantic-ui-react';


const ProjectChangesDropdown = ({t, dates}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="dropdown-container" ref={dropdownRef}>
      <Button icon labelPosition="right" onClick={() => setIsOpen(!isOpen)}>
        <Icon name="arrow down" />
        {t("changeHistory.details")}
        </Button>

      {isOpen && (
        <div className="dropdown-menu">
          { 
                dates.map((job, ind) => {
                    let by = "";
                    if((job.updatedBy ?? null) !== null){
                        by = ` ${t("changeHistory.by")} ` + (job.updatedBy?.name ?? "");
                    }
                    let mod = "";
                    let ordersMod = [];
                    let disposMod = [];
                    let deploymentsMod = [];
                    if(job.updatedRecords.detailsUpdated ?? false){
                        mod = <li>{t("changeHistory.jobDetailsModifiedOn")}<i>{moment(job.updatedRecords.detailsUpdatedBy).format("YYYY-MM-DD HH:mm:ss")}</i></li>;
                    }
                    if((job.updatedRecords.materialOrders ?? []).length > 0){
                        ordersMod = job.updatedRecords.materialOrders.map((item) => {

                            return <li>{t("changeHistory.materialUpdatedOn", {material: (item.material.name ?? "")})}<i>{moment(item.updatedAt).format("YYYY-MM-DD HH:mm:ss")}</i></li>;
                        });
                    }
                    if((job.updatedRecords.trucks ?? []).length > 0){
                        disposMod = job.updatedRecords.trucks.map((item) => {

                            return <li>{t("changeHistory.transportUpdatedOn", {type: (item.truckType.name ?? "")})}<i>{moment(item.updatedAt).format("YYYY-MM-DD HH:mm:ss")}</i></li>;
                        });
                    }
                    if(job.updatedRecords.deploymentsUpdated ?? false){
                        deploymentsMod = <li>{t("changeHistory.deploymentsUpdatedOn")}<i>{moment(job.updatedRecords.deploymentUpdatedAt).format("YYYY-MM-DD HH:mm:ss")}</i></li>;
                    }
                    return (
                        <div className="changeContainer">
                            <div className="project changehistory" key={job.id}>
                                <div className="timed">
                                    { moment(job.start).format("YYYY-MM-DD")}
                                </div>
                                <div className="name">
                                    {job.process}
                                </div>
                                <div className="lastmodified">
                                    {t("changeHistory.lastModified")} <i>{moment(job.updated).format("YYYY-MM-DD HH:mm:ss")}</i>&nbsp;{by}
                                </div>    
                            </div>
                            <ul className="changeHistoryList">
                                {mod} {ordersMod.map(item => item)} {disposMod.map(item => item)} {deploymentsMod}
                            </ul>
                        </div>
                    
                )})
            }
        </div>
      )}
    </div>
  );
};

export default ProjectChangesDropdown;